import React from "react";
import "./App.css";
import ApplicantForm from "./components/ApplicantForm";

const App = () => {
  return (
    <div className="App">
      <ApplicantForm />
    </div>
  );
};

export default App;

// import "./App.css";
// import Form from "./components/Form";

// function App() {
//   return (
//     <div className="App">
//       <Form />
//     </div>
//   );
// }

// export default App;
